import { Injectable } from '@angular/core'

import { Observable } from 'rxjs'
import { map, tap } from 'rxjs/operators'
import { ClubAdapter } from '../../shared/adapters/ClubAdapter'
import { IssueOptionsResponseSchema } from '../issue/issue.model'
import { IssueOptionsRequest, IssueOptionsResponse } from '../issue/issue.types'
import {
  ClubConfigResponse,
  ServicesConfiguration,
} from './servicing-club.types'
import { DrrHttpClient } from '../../http/drr-http-client'

@Injectable({ providedIn: 'root' })
export class ServicingClubService {

  constructor(
    private clubAdapter: ClubAdapter,
    private httpClient: DrrHttpClient,
  ) {}

  getServicingClubConfigs$(club: string): Observable<ServicesConfiguration> {
    return this.httpClient
      .get<ClubConfigResponse>(`/bff/club/${club}/config`)
      .pipe(map((response) => this.clubAdapter.adaptClubConfig(response)))
  }

  getIssueOptions$(request: IssueOptionsRequest): Observable<IssueOptionsResponse> {
    const fuelTypeParam = request.fuelType ? `fuelType=${encodeURIComponent(request.fuelType)}` : '';
    return this.httpClient
      .get<IssueOptionsResponse>(`/bff/club/${request.club}/options?${fuelTypeParam}`, {
        params: {
          latitude: request.latitude.toString(),
          longitude: request.longitude.toString(),
          ...(request.vehicleType ? { vehicleType: request.vehicleType } : {}),
        },
      })
      .pipe(
        tap((response) => IssueOptionsResponseSchema.validateSync(response))
      )
  }
}
